
import fa from './fa';
import tou from './tou';
import kai from './kai';
import ping from './ping';
import ding from './ding';
import fangan from './fang-an';

export default {
    path: 'projectflow',
    redirect: 'projectflow/list',
    component: () => import(/*webpackChunkName: 'bidding-project'*/ '@layout/empty'),
    children: [
        fa,
        tou,
        kai,
        ping,
        ding,
        fangan,
    ]
}